<div class="dynamic-container">
    <div
        class="dynamic-fields"
        [ngClass]="{
            dynamicFieldsWithoutPadding:
                fieldPair.fieldSchema.fieldType === FieldTypeEnum.GroupField
        }"
        [style.flex-basis]="fieldPair.fieldSchema.width || '100%'"
        [style.max-width]="fieldPair.fieldSchema.width || '100%'"
        [style.margin]="fieldPair.fieldSchema.margin || 0"
        *ngFor="let fieldPair of this.pairs"
    >
        <dr-label-field
            *ngIf="fieldPair.fieldSchema.fieldType === FieldTypeEnum.LabelField && !reviewMode"
            [fieldSchema]="fieldPair.fieldSchema"
        ></dr-label-field>
        <dr-download-all-documents-field
            *ngIf="
                fieldPair.fieldSchema.fieldType === FieldTypeEnum.DownloadAllDocumentsField &&
                !reviewMode
            "
            [label]="fieldPair.fieldSchema.label"
            [prospectDataId]="prospectDataId"
        >
        </dr-download-all-documents-field>
        <dr-add-document-field
            *ngIf="
                fieldPair.fieldSchema.fieldType === FieldTypeEnum.AddDocumentField && !reviewMode
            "
            [label]="fieldPair.fieldSchema.label"
            [prospectDataId]="prospectDataId"
            [schemaType]="schemaType"
            [adminMode]="adminMode"
            class="doc-center-add-document page-container"
        >
        </dr-add-document-field>
        <dr-add-document-list-field
            *ngIf="
                fieldPair.fieldSchema.fieldType === FieldTypeEnum.AddDocumentListField &&
                !reviewMode
            "
            [label]="fieldPair.fieldSchema.label"
            [prospectDataId]="prospectDataId"
            [schemaType]="schemaType"
            [adminMode]="adminMode"
            class="doc-center-add-document page-container"
        >
        </dr-add-document-list-field>
        <dr-string-field
            *ngIf="fieldPair.fieldSchema.fieldType === FieldTypeEnum.StringField && !reviewMode"
            [formGroup]="formGroup"
            [fieldSchema]="fieldPair.fieldSchema"
            [field]="fieldPair.fieldData"
            [reviewMode]="reviewMode"
        ></dr-string-field>
        <dr-dropdown-field
            *ngIf="fieldPair.fieldSchema.fieldType === FieldTypeEnum.DropdownField && !reviewMode"
            [formGroup]="formGroup"
            [fieldSchema]="fieldPair.fieldSchema"
            [field]="fieldPair.fieldData"
            [reviewMode]="reviewMode"
        ></dr-dropdown-field>
        <dr-document-field
            *ngIf="fieldPair.fieldSchema.fieldType === FieldTypeEnum.DocumentField && !reviewMode"
            [formGroup]="formGroup"
            [fieldSchema]="fieldPair.fieldSchema"
            [field]="fieldPair.fieldData"
            [adminMode]="adminMode"
            [reviewMode]="reviewMode"
            [stageSchema]="stageSchema"
            [schemaType]="schemaType"
        ></dr-document-field>
        <dr-review-field
            *ngIf="reviewMode"
            [fieldSchema]="fieldPair.fieldSchema"
            [field]="fieldPair.fieldData"
            [adminMode]="adminMode"
        ></dr-review-field>
        <dr-edit-phone
            *ngIf="fieldPair.fieldSchema.fieldType === FieldTypeEnum.EditPhoneField"
            [fieldSchema]="fieldPair.fieldSchema"
        >
        </dr-edit-phone>
    </div>
</div>
